import React from 'react'
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import { themeConWeb } from '../../util/modernThemeConweb'
import { parseLeadTimeInHours } from '../../util/cateringUtils'

const RestaurantPreparationDetails = ({ cateringLeadTime, maxWeight }) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          paddingTop: 10,
          color: themeConWeb.color.greyShade5,
        }}
      >
        <p style={{ display: 'flex', alignItems: 'center' }}>
          <AccessTimeIcon />
          <span style={{ marginLeft: '10px' }}>
            {parseLeadTimeInHours(cateringLeadTime)} hour delivery notice
          </span>
        </p>
        <p style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
          {' '}
          <PeopleOutlineIcon />
          <span style={{ marginLeft: '5px' }}>
            Good for up to <b>{maxWeight} people</b>
          </span>
        </p>
      </div>
    </>
  )
}

export default RestaurantPreparationDetails
